module.exports = __webpack_public_path__ + "img/instruction_fullorder_2d.f6298008.png";